import {Box, HBox} from '@buncha/components/core/view';
import {CustomText, H4Text, H6Text} from '@buncha/components/core/text';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {CustomImage} from '@buncha/components/core/Image';
import {ItemDetailsScreen} from '@buncha/itemDetails/navigation/types';
import ItemName from '@buncha/batchDetails/component/ItemName';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import {formatCurrency} from '@buncha/utils/common';
import {useGetLocale} from '@buncha/localization/hooks';
import {useNSCItemScannerContext} from '@buncha/itemDetails/hooks/NSCItemScanner';

const NSCItemDetails = () => {
  const {state} = useNSCItemScannerContext();
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const {body} =
    useGetLocale(Modules.itemDetails, ItemDetailsScreen.NSCItemScanner) ?? {};
  const item = state.item;
  const currentBuyer = state.buyers?.[0];
  if (!item || !currentBuyer) return <></>;
  return (
    <Box>
      <HBox style={styles.detailsContainer}>
        <Box style={styles.imageBox}>
          <CustomImage
            style={styles.image}
            source={item.itemImageUrl}
            resizeMode="cover"
            onErrorSource={''}
          />
        </Box>
        <Box style={styles.textContainer}>
          <Box style={styles.itemNameContainer}>
            <ItemName name={item.name ?? ''} />
          </Box>
          <H6Text
            style={{
              fontFamily: muliFont[700].normal,
              color: theme?.text.blue[300],
            }}>
            {formatCurrency(item.price || 0)}
          </H6Text>
        </Box>
      </HBox>
      <HBox style={styles.buyerDetails}>
        <Box style={styles.buyerContainer}>
          <H6Text>{body?.scanningFor}</H6Text>
          <H4Text
            style={{
              color: theme?.text?.blue?.[300],
              fontFamily: muliFont[700].normal,
            }}>
            {currentBuyer?.firstName} {currentBuyer?.lastName}
          </H4Text>
        </Box>

        <HBox
          style={[
            styles.highlightText,
            {
              backgroundColor: theme?.background.yellow[100],
            },
          ]}>
          <CustomText
            style={{
              fontFamily: muliFont[700].normal,
              color: theme?.text.blue[300],
            }}>{`${body?.reminderPickWgt}${
            currentBuyer?.orderItemAttribute?.weight
              .toFixed(2)
              .replace(/[.,]00$/, '') || 1
          } ${currentBuyer?.orderItemAttribute?.units} `}</CustomText>
        </HBox>
      </HBox>
    </Box>
  );
};

export default React.memo(NSCItemDetails);

const styles = StyleSheet.create({
  detailsContainer: {
    justifyContent: 'flex-start',
    marginBottom: 15,
    paddingHorizontal: 20,
  },
  imageBox: {position: 'relative'},
  image: {
    height: 75,
    width: 75,
  },
  textContainer: {
    alignItems: 'flex-start',
    marginLeft: 10,
    flex: 1,
  },
  itemNameContainer: {marginBottom: 10},
  highlightText: {
    borderRadius: 20,
    padding: 5,
    alignSelf: 'center',
    zIndex: 3,
  },
  buyerContainer: {alignItems: 'flex-start'},
  buyerDetails: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    paddingHorizontal: 20,
  },
});
